exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".delimiter--2aiBB {\n\tmargin: 10px -40px 0;\n\tpadding-bottom: 20px;\n\tborder-top: 1px solid #e2e2e2;\n}\n\n\t.delimiter--2aiBB.noMarge--2M0f3 {\n\t\tmargin-left: -20px;\n\t\tmargin-right: -20px;\n\t}", ""]);

// Exports
exports.locals = {
	"delimiter": "delimiter--2aiBB",
	"noMarge": "noMarge--2M0f3"
};